const showLoadingIndicator = () => {
    const loaderEl = document.getElementById("loader");
    if (loaderEl) loaderEl.style.display = "flex";
  };
  
  const hideLoadingIndicator = () => {
    const loaderEl = document.getElementById("loader");
    if (loaderEl) loaderEl.style.display = "none";
  };

  export const TextInputUtils = {
    showLoadingIndicator,
    hideLoadingIndicator
  };